import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DetailAddonInfoChannels = styled.div<React.CSSProperties>`
  font-family: ${Fonts['regular']};
  color: ${Colors['light']};
  font-size: ${Screen.widthRatio * 32}px;
  margin-right: ${Screen.widthRatio * 110}px;
`;

export default DetailAddonInfoChannels;
